/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpLeftIcon16Regular = forwardRef('ArrowAUpLeftIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.75 3a.75.75 0 0 1 0 1.5H5.56l7.47 7.47a.75.75 0 1 1-1.06 1.06L4.5 5.56v5.19a.75.75 0 0 1-1.5 0v-6C3 3.784 3.784 3 4.75 3h6Z" })));
});
